import styled from 'styled-components/macro';
import { baseSpacing, colors } from 'css/constants';
import { H2 } from '@sohonet/ui-components/Typography';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const FormHeader = styled(H2)`
  margin: 0;
`;

export const FormSectionsHeader = styled.h5`
  margin: 0;
  color: ${colors.sohoGray};
`;

export const FormBody = styled.div`
  position: relative;
  padding: ${baseSpacing / 2}px ${baseSpacing}px;
  overflow: visible;
`;

export const FormFooter = styled.div`
  text-align: right;
  position: relative;
  padding: ${baseSpacing / 2}px ${baseSpacing}px;
`;

export const FormSection = styled.section.attrs((props) => ({
  gridRowGap: props.gridRowGap || 'unset',
  gridTemplateCols: props.gridTemplateCols || 'repeat(2, 1fr)',
  noMarginBottom: (props.noMarginBottom && '0') || `${baseSpacing / 2}px`
}))`
  display: grid;
  grid-template-columns: ${({ gridTemplateCols }) => gridTemplateCols};
  grid-column-gap: ${baseSpacing}px;
  grid-row-gap: ${({ gridRowGap }) => gridRowGap};
  margin-bottom: ${({ noMarginBottom }) => noMarginBottom};

  h3 {
    margin-bottom: ${baseSpacing / 6}px;
    grid-column: 1/3;
  }
`;

export const FormCreditInfoSection = styled.section.attrs((props) => ({
  gridTemplateCols: props.gridTemplateCols || '3fr 1fr'
}))`
  display: grid;
  grid-template-columns: ${({ gridTemplateCols }) => gridTemplateCols};
  grid-column-gap: ${baseSpacing}px;
  margin: 0;
`;

export default Form;
